import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  IconButton,
  Paper,
  Zoom,
} from '@mui/material';
import {
  LibraryBooks,
  FileDownload,
  ArrowForward,
} from '@mui/icons-material';
import { Card } from '../components/Card';

const cardOptions = [
  {
    title: 'Answer Library',
    icon: <LibraryBooks sx={{ fontSize: 56, color: 'primary.main' }} />,
    path: '/library',
    description: 'Browse and manage curated answers.',
  },
  // {
  //   title: 'AI Answer Drafts',
  //   icon: <SmartToy sx={{ fontSize: 56, color: 'primary.main' }} />,
  //   path: '/drafts',
  //   description: 'Review and edit AI-generated draft answers.',
  // },
  {
    title: 'Export',
    icon: <FileDownload sx={{ fontSize: 56, color: 'primary.main' }} />,
    path: '/export',
    description: 'Export DDQ results and reports.',
  },
];

const DDQ: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Paper sx={{ mb: 3, p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="h4">DDQ Options</Typography>
      </Paper>

      <Paper sx={{ width: '100%', height: '85vh', display: 'flex', flexDirection: 'column', p: 3 }}>
        <Box sx={{ flexGrow: 1, overflowY: 'auto', p: 3, pt: 0 }}>
          <Box sx={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
            gap: 3,
            justifyContent: 'center',
            maxWidth: '1200px',
            margin: '0 auto'
          }}>
            {cardOptions.map((option, index) => (
              <Zoom in timeout={300 + index * 100} key={option.title}>
                <Card
                  variant="interactive"
                  onClick={() => navigate(option.path)}
                  sx={{
                    minHeight: '220px',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    textAlign: 'center',
                    '&:hover': {
                      transform: 'translateY(-4px)',
                      boxShadow: '0 12px 32px rgba(0,0,0,0.15)',
                    }
                  }}
                >
                  <Card.Content sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                    {option.icon}
                    <Typography variant="h6" sx={{ mt: 2, fontWeight: 600 }}>
                      {option.title}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                      {option.description}
                    </Typography>
                  </Card.Content>
                  <Card.Footer sx={{ justifyContent: 'flex-end' }}>
                    <IconButton>
                      <ArrowForward />
                    </IconButton>
                  </Card.Footer>
                </Card>
              </Zoom>
            ))}
          </Box>
        </Box>
      </Paper>
    </Box>
  );
};

export default DDQ;